import { DateTime } from 'luxon';

import { DateUtilities } from './date-utilities';

export class PopupRangeParameters
{
    /**
     * @param {DateTime} initSince Since initial fournit lors de la création du composant
     * @param {DateTime} initUntil Until initial fournit lors de la création du composant
     * @param {DateTime} minDate Date minimale acceptable
     * @param {DateTime} maxDate Date maximale acceptable
     */
    constructor (
        public initSince: DateTime,
        public initUntil: DateTime,
        public minDate: DateTime,
        public maxDate?: DateTime
    )
    {
        if (!maxDate)
        {
            this.maxDate = DateUtilities.getMaxDate ();
        }
    }
}
